import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errorText } from "../api";
import { Alerts, ConfirmDialog, Facts, Page } from "../components/ui";
import { text } from "../format";

const MEANING = {
  "Admin BEP20 address is missing": "The admin account has no BEP20 address and private key yet.",
  "BNBRPC is missing": "The BSC RPC is not set.",
};

export default function Bep20Sweep() {
  const [ask, setAsk] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [result, setResult] = useState(null);

  function close() {
    if (busy) return;
    setAsk(false);
  }

  async function run() {
    setBusy(true);
    setError("");
    setNotice("");
    try {
      const payload = await api("/bep20-sweep", { method: "POST" });
      setResult(payload.data || {});
      setNotice(payload.message || "BEP20 sweep finished");
      setAsk(false);
    } catch (err) {
      const message = errorText(err) || "BEP20 sweep failed";
      setError(MEANING[message] ? message + " " + MEANING[message] : message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Page
      title="Sweep all users"
      text="One sweep for every member BEP20 deposit address. If that address holds a token and does not already have enough BNB for gas, the admin address sends the missing gas. Tokens and leftover BNB then move to the admin wallet. RECEIVE_ADD is used when it is set. Otherwise the admin BEP20 address receives the funds. This does not change the member site wallet balance. The same sweep also runs every hour."
      actions={<button type="button" className="btn" disabled={busy} onClick={() => { setError(""); setAsk(true); }}>Sweep all users</button>}
    >
      <Alerts error={ask ? "" : error} notice={notice} />
      {result ? (
        <div className="panel">
          <Facts items={[
            { label: "Addresses checked", value: result.users ?? 0 },
            { label: "Gas top-ups", value: result.gasSent ?? 0 },
            { label: "Receive address", value: <span className="mono">{text(result.receiveAddress)}</span>, wide: true },
          ]} />
          <p className="hint">Sweep rows are on <Link to="/admin/bep20-deposits?transactionType=Transfer">BEP20 deposits</Link>, filtered to Transfer.</p>
        </div>
      ) : (
        <p className="hint">Admin BEP20 address is missing means the admin account has no BEP20 address and private key yet. BNBRPC is missing means the BSC RPC is not set.</p>
      )}
      {ask ? (
        <ConfirmDialog
          title="Sweep all users"
          text="This checks every member BEP20 address. Missing gas is sent from the admin address, then tokens and leftover BNB move to the admin wallet. Member site wallet balances stay the same."
          error={error}
          busy={busy}
          danger
          confirmLabel="Sweep all users"
          onClose={close}
          onConfirm={run}
        />
      ) : null}
    </Page>
  );
}
